import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
export const Input = forwardRef(({ style, onFocus, onBlur, ...props }, ref) => {
    const [focused, setFocused] = useState(false);
    return (_jsx("input", { ref: ref, className: "wp-input", style: {
            display: 'flex', height: '40px', width: '100%',
            borderRadius: 'var(--radius-md)',
            border: `1px solid ${focused ? 'var(--color-text)' : 'var(--color-border)'}`,
            background: 'var(--color-surface)',
            padding: '0 12px',
            fontSize: '0.875rem', fontFamily: 'var(--font-family-body)',
            color: 'var(--color-text)',
            outline: 'none',
            boxShadow: focused ? 'var(--shadow-focus)' : 'none',
            transition: 'border-color 80ms ease, box-shadow 80ms ease',
            boxSizing: 'border-box',
            ...style,
        }, onFocus: (e) => { setFocused(true); onFocus?.(e); }, onBlur: (e) => { setFocused(false); onBlur?.(e); }, ...props }));
});
Input.displayName = 'Input';
